/* eslint-disable import/no-anonymous-default-export */
import { useChangelanguajeMutation } from '../generated/graphql'
export default () => {
    const [mutation] = useChangelanguajeMutation()
    return (props: any) => {
        return mutation({
            variables: props
        })
    }
};